import React, { useRef, useState, useCallback, useLayoutEffect, useEffect } from 'react';
import '../../../Styles/Layout/Items/HoverToolTip.css';

interface HoverToolTipProps {
  text: string;
  position: 'top' | 'bottom' | 'left' | 'right';
  keybinding?: string;
}

export const HoverToolTip = ({ text, position, keybinding }: HoverToolTipProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);  // added ref for tooltip div
  const [offset, setOffset] = useState({ x: 0, y: 0 });  // state to track offset adjustments

  const adjustPosition = useCallback(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      let offsetX = 0;
      let offsetY = 0;
      if (rect.left < 0) {
         offsetX = -rect.left;
      } else if (rect.right > window.innerWidth) {
         offsetX = window.innerWidth - rect.right;
      }
      if (rect.top < 0) {
         offsetY = -rect.top;
      } else if (rect.bottom > window.innerHeight) {
         offsetY = window.innerHeight - rect.bottom;
      }
      setOffset({ x: offsetX, y: offsetY });
    }
  }, []);

  useLayoutEffect(() => {
    adjustPosition();
  }, [adjustPosition, text]);

  useEffect(() => {
    window.addEventListener('resize', adjustPosition);
    return () => {
      window.removeEventListener('resize', adjustPosition);
    };
  }, [adjustPosition]);

  let transformStyle = '';
  switch(position) {
    case 'top':
      transformStyle = `translateX(calc(-50% + ${offset.x}px)) translateY(calc(5px + ${offset.y}px)) translateZ(0)`;
      break;
    case 'bottom':
      transformStyle = `translateX(calc(-50% + ${offset.x}px)) translateY(calc(-5px + ${offset.y}px)) translateZ(0)`;
      break;
    case 'left':
      transformStyle = `translateY(calc(-50% + ${offset.y}px)) translateX(calc(5px + ${offset.x}px)) translateZ(0)`;
      break;
    case 'right':
      transformStyle = `translateY(calc(-50% + ${offset.y}px)) translateX(calc(-5px + ${offset.x}px)) translateZ(0)`;
      break;
    default:
      transformStyle = '';
  }

  return (
    <span ref={tooltipRef} className={`hover-tooltip ${position}`} style={{ transform: transformStyle }}>
      <span className="hover-tooltip-content">
        {text}
      </span>
      {keybinding && <span className="hover-tooltip-keybinding">{keybinding}</span>}
    </span>
  );
};